<div class="row">
  <div
    class="brand col-xs-5 col-md-4"
    property="publisher"
    typeof="GovernmentOrganization"
  >
    <a href="{{'application_features.publicHeader.url' | translate}}" property="url"
    ><img
      src="{{gcLogo}}"
      alt=""
      property="logo"
    /><span class="wb-inv" property="name">
        Government of Canada /
        <span lang="fr">Gouvernement du Canada</span></span
    ></a
    >
    <meta property="areaServed" typeof="Country" content="Canada"/>
    <link
      property="logo"
      href="assets/themes-dist-10.5.2-gcweb/GCWeb/assets/wmms-blk.svg"
    />
  </div>
  <section id="wb-srch" class="col-lg-8 text-right" *ngIf="(isLoggedIn$ | async) !== true">
    <h2>{{'application_features.publicHeader.searchBtnLabel' | translate}}</h2>
    <form action="{{'application_features.publicHeader.actionUrl' | translate}}" method="get" name="cse-search-box" role="search"
          class="form-inline">
      <div class="form-group">
        <label for="wb-srch-q" class="wb-inv">{{'application_features.publicHeader.searchPlaceholder' | translate}}</label>
        <input name="cdn" value="canada" type="hidden">
        <input name="st" value="s" type="hidden">
        <input name="num" value="10" type="hidden">
        <input name="langs" value="en" type="hidden">
        <input name="st1rt" value="1" type="hidden">
        <input name="s5bm3ts21rch" value="x" type="hidden">
        <input id="wb-srch-q" list="wb-srch-q-ac" class="wb-srch-q form-control" name="q" type="search" value=""
               size="34" maxlength="170" placeholder="{{'application_features.publicHeader.searchPlaceholder' | translate}}" #searchVal autocomplete="off">
        <input type="hidden" name="_charset_" value="UTF-8">
        <datalist id="wb-srch-q-ac">
        </datalist>
      </div>
      <div class="form-group submit">
        <button type="submit" id="wb-srch-sub" class="btn btn-primary btn-small" name="wb-srch-sub" (click)="search(searchVal.value)"><span
          class="glyphicon-search glyphicon"></span><span class="wb-inv">{{'application_features.publicHeader.searchBtnLabel' | translate}}</span></button>
      </div>
    </form>
  </section>
</div>
